var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "md", type: "dark", variant: "dark" } },
        [
          _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
          _c("b-navbar-brand", { attrs: { to: "/" } }, [_vm._v("Accueil")]),
          _c(
            "b-collapse",
            { attrs: { id: "nav_collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                [
                  _c("b-nav-item", { attrs: { to: "/saisie" } }, [
                    _vm._v("Saisies"),
                  ]),
                  _c("b-nav-item", { attrs: { to: "/projet" } }, [
                    _vm._v("Projets"),
                  ]),
                  _c("b-nav-item", { attrs: { to: "/adherent" } }, [
                    _vm._v("Adhérents"),
                  ]),
                  _c("b-nav-item", { attrs: { to: "/referentiels" } }, [
                    _vm._v("Référentiels"),
                  ]),
                  _c("b-nav-item", { attrs: { to: "/recus-fiscaux" } }, [
                    _vm._v("Reçus fiscaux"),
                  ]),
                ],
                1
              ),
              _vm.user
                ? _c(
                    "b-navbar-nav",
                    { staticClass: "ml-auto" },
                    [
                      _c(
                        "b-nav-text",
                        { staticClass: "font-weight-bold mr-3" },
                        [_vm._v(" " + _vm._s(_vm.user.name) + " ")]
                      ),
                      _c(
                        "b-nav-item",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: { href: "#", title: "Se déconnecter" },
                          on: { click: _vm.logout },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "iconRightSpace",
                            attrs: { icon: "sign-out-alt" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "keep-alive",
        { attrs: { include: "projet" } },
        [_c("router-view")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }